var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 15.0833H18.75V10.9167H22.9167M22.9167 31.75H18.75V19.25H22.9167M20.8333 0.5C18.0975 0.5 15.3884 1.03887 12.8608 2.08584C10.3331 3.13282 8.0365 4.66739 6.10194 6.60194C2.19493 10.509 0 15.808 0 21.3333C0 26.8587 2.19493 32.1577 6.10194 36.0647C8.0365 37.9993 10.3331 39.5339 12.8608 40.5808C15.3884 41.6278 18.0975 42.1667 20.8333 42.1667C26.3587 42.1667 31.6577 39.9717 35.5647 36.0647C39.4717 32.1577 41.6667 26.8587 41.6667 21.3333C41.6667 18.5975 41.1278 15.8884 40.0808 13.3608C39.0339 10.8331 37.4993 8.5365 35.5647 6.60194C33.6302 4.66739 31.3335 3.13282 28.8059 2.08584C26.2783 1.03887 23.5692 0.5 20.8333 0.5Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsIcon);
export default __webpack_public_path__ + "static/media/aboutUsIcon.736dee22299dba37d06138cb23cc8254.svg";
export { ForwardRef as ReactComponent };